export enum BugInformation {
    PLE_Bug = 1,
    MSFT_Devices_Non_PLE_Bug,
    OS_Bug,
    Hub_OS_Bug,
    Other_Bugs,
    Azure_Devops_Link
}